import Vue from 'vue'
import { WidgetApi } from '@/api/widgetApi'
import { WidgetDataApi } from '@/api/widgetDataApi'
import { isExternalDataWidget } from '@/helpers/widgetUtils'
import { editModeState } from '@/composables/globalData/useDashoardsData'

export function removeDummyWidgets (widgetIds) {
    widgetIds.forEach((id) => {
        WidgetApi.destroy(id)
    })
}

export async function getWidgetData (widget, config = {}) {
    try {
        if (isWidgetModalOpen() || isInEditMode() || !widget.EndPoint) {
            return null
        }

        Vue.set(widget, 'onLoading', true)

        if (isExternalDataWidget(widget)) {
            return await WidgetDataApi.getExternalData(widget.EndPoint, config)
        }

        return await WidgetDataApi.getData(widget.EndPoint, config)
    } catch (e) {
        console.error(e)
    } finally {
        Vue.set(widget, 'onLoading', false)
    }
}

export function isWidgetModalOpen () {
    const bodyElement = document.body
    return bodyElement.classList.contains('el-popup-parent--hidden')
}

export function isInEditMode () {
    return editModeState.value
}
